import { render, staticRenderFns } from "./TableServicesDetailQuote.vue?vue&type=template&id=d65cc758"
import script from "./TableServicesDetailQuote.vue?vue&type=script&lang=js"
export * from "./TableServicesDetailQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports